import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

export default function Analytics() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>Analytics</Typography>
      <Paper sx={{ p: 3, mt: 2 }}>
        <Typography variant="body1" color="text.secondary">
          Analytics dashboard coming soon. Track redemptions, user engagement, ROI, and more.
        </Typography>
      </Paper>
    </Box>
  );
}
